import { Component, Input, ElementRef, ViewChild, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { UtilitiesService } from '../../../services/utilities.service';
import { Notification, NotificationStatusEnum } from '../../../models/communication/Notification.model';
import { DialogsService } from '../../../services/dialogs.service';
import { NotificationsOverlayList } from '../notifications-overlay-list/notifications-overlay-list.component';

@Component({
    selector: 'notifications-menu--item',
    templateUrl: 'notifications-menu--item.component.html',
    styleUrls: ['notifications-menu--item.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class NotificationsMenuItem implements AfterViewInit {

    @Input() notification: Notification;

    private diffTime: number;

    public notificationsTypes = NotificationStatusEnum;

    constructor(
        private utils: UtilitiesService,
        private dialogService: DialogsService
    ) {}

    ngAfterViewInit() {
    }

    /**
     * Retorna o tempo da notificação em relação a hoje.
     */
    public setDiffTime() {
        let time = this.utils.diffTime(new Date(), new Date(this.notification.sendDate), 'minute');
        if ( time < 60 ) {
            return `${Math.round(time)} minutos`;
        } else if( time >= 60 && time <= 1440) {
            return `${Math.round(time / 60) } horas`
        } else {
            return `${Math.round(time / (24 * 60))} dias`
        }
    }

    /**
     * Abre as notificações com a notificação selecionada aberta
     * @param notification Notificação a ser aberta
     */
    openOverlay(notification: Notification) {
        this.dialogService.showComponnent(NotificationsOverlayList, {messageID: notification.messageID});
    }

}